import { actions } from './AuthUserReducer';

export function attemptSetAccessDenied(data) {
    return { type: actions.ATTEMPT_SET_ACCESS_DENIED, payload: { data } };
  }
